import React from 'react';

import { flagStyles } from '../settings';

const SvgPS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4344px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPS;
